/* tslint:disable */
/* eslint-disable */
/**
 * Melco Rest Services
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MelcoModelsUserSubscription
 */
export interface MelcoModelsUserSubscription {
    /**
     * 
     * @type {string}
     * @memberof MelcoModelsUserSubscription
     */
    new_user_reference_id?: string | null;
}

export function MelcoModelsUserSubscriptionFromJSON(json: any): MelcoModelsUserSubscription {
    return MelcoModelsUserSubscriptionFromJSONTyped(json, false);
}

export function MelcoModelsUserSubscriptionFromJSONTyped(json: any, ignoreDiscriminator: boolean): MelcoModelsUserSubscription {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'new_user_reference_id': !exists(json, 'new_user_reference_id') ? undefined : json['new_user_reference_id'],
    };
}

export function MelcoModelsUserSubscriptionToJSON(value?: MelcoModelsUserSubscription | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'new_user_reference_id': value.new_user_reference_id,
    };
}


